import React, { useState, useEffect, useMemo } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Checkbox } from 'primereact/checkbox';
import { useLanguage } from '../../../contexts/LanguageContext';
import { useSelector } from 'react-redux';
import { selectUserParams } from '../../../store/slices/userParamsSlice';
import { usePermissions } from '../../../hooks/usePermissions';
import toastService from '../../../utils/toastService';
import { RadioButton } from 'primereact/radiobutton'; 
import ExternalPartsDropdown from '../../warranty-management/warranty-requests/warranty-claims/createEditForm/warrantyClaimsDetailTabs/detailDialogForms/ExternalPartsDropdown';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import ItemCodeDropdown from '../../../components/common/ItemCodeDropdown';
const BlockShelfSeqItemDescriptionForm = ({
    visible,
    onHide,
    onSubmit,
    onDelete,
    initialData = null,
    isLoading = false,
    dealerId,
    dealerAddressId
}) => {
    const { th } = useLanguage();
    const userParams = useSelector(selectUserParams);
    const { hasDealerRole, hasServiceDealerRole, hasSalesDealerRole } = usePermissions();

    // Dealer kontrolü
    const isDealer = hasDealerRole() || hasServiceDealerRole() || hasSalesDealerRole();

const handlePartSourceChange = (value) => {
    setFormData((prev) => ({
        ...prev,
        partBrand: value,
        partCode: '',
        partDesc: ''
    }));
};
const handleDelete = () => {
    confirmDialog({
        message:
            th('blockShelfSeqItemDescription.confirmDelete') ||
            'Bu kaydı silmek istediğinize emin misiniz?',
        header:
            th('blockShelfSeqItemDescription.deleteHeader') ||
            'Silme Onayı',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            if (onDelete && initialData) {
                onDelete(initialData);
            }
        },
        rejectClassName: 'p-button-outlined'
    });
};

    const [submitted, setSubmitted] = useState(false);
    const [formData, setFormData] = useState({
        partCode: '',
        partDesc: '',
        block: null,
        shelf: null,
        sequence: null,
        eyes: null,
        isActive: 1,
        partBrand: 0
    });


    useEffect(() => {
        if (visible) {
            if (initialData) {
                setFormData({
                    partCode: initialData.partCode || '',
                    partDesc: initialData.partDesc || '',
                    block: initialData.block || null,
                    shelf: initialData.shelf || null,
                    sequence: initialData.sequence || null,
                    eyes: initialData.eyes || null,
                    isActive: initialData.isActive !== undefined ? initialData.isActive : 1,
                    partBrand: initialData.partBrand ?? 0                   
                    
                });
            } else {
                setFormData({
                    partCode: '',
                    partDesc: '',
                    block: null,
                    shelf: null,
                    sequence: null,
                    eyes: null,
                    isActive: 1,
                    partBrand: 0
                });
            }
            setSubmitted(false);
        }
    }, [visible, initialData]);

    const handleChange = (field, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: value
        }));
    };

    const validateForm = () => {
        const errors = {};
        
        if (!formData.partCode) {
            errors.partCode =
                th('blockShelfSeqItemDescription.validation.partCodeRequired') ||
                'Parça Kodu zorunludur';
}
        
        if (!formData.partDesc?.trim()) {
            errors.partDesc = th('blockShelfSeqItemDescription.validation.partDescRequired') || 'Parça Açıklaması zorunludur';
        }
        if (formData.partBrand === null || formData.partBrand === undefined) {
    errors.partBrand =
        th('blockShelfSeqItemDescription.validation.partSourceRequired') ||
        'Parça Kaynağı zorunludur';
}

        return Object.keys(errors).length === 0;
    };

    const handleSubmit = async () => {
        setSubmitted(true);
        
        if (!validateForm()) {
            toastService.error(th('blockShelfSeqItemDescription.validation.formInvalid') || 'Lütfen zorunlu alanları doldurun');
            return;
        }

        const payload = {
            partCode: formData.partCode,
            partDesc: formData.partDesc.trim(),
            block: formData.block || null,
            shelf: formData.shelf || null,
            sequence: formData.sequence || null,
            eyes: formData.eyes || null,
            bosBranchCode: userParams.dealerId?.toString() || null,
            bosBranchSiteCode: userParams.siteUseId?.toString() || null,
            isActive: formData.isActive,
            dealerId: userParams.dealerId,
            dealerAddressId: userParams.addrId,
            partBrand: formData.partBrand
        };
       
        if (initialData?.id) {
            payload.id = initialData.id;
        }

        try {
            await onSubmit(payload);
            onHide();
        } catch (error) {
            console.error('Form submit error:', error);
        }
    };
const renderFooter = () => {
    return (
        <div className="flex justify-content-between">
            <div>
                {initialData && (
                    <Button
                        label={th('common.delete') || 'Sil'}
                        icon="pi pi-trash"
                        className="p-button-danger"
                        onClick={handleDelete}
                        disabled={isLoading}
                    />
                )}
            </div>

            <div className="flex gap-2">
                <Button
                    label={th('common.cancel') || 'Vazgeç'}
                    icon="pi pi-times"
                    onClick={onHide}
                    className="p-button-secondary"
                    disabled={isLoading}
                />
                <Button
                    label={th('common.save') || 'Kaydet'}
                    icon="pi pi-check"
                    onClick={handleSubmit}
                    loading={isLoading}
                />
            </div>
        </div>
    );
};

    return (
        <Dialog
            header={initialData ? (th('blockShelfSeqItemDescription.editTitle') || 'Kalem Düzenle') : (th('blockShelfSeqItemDescription.createTitle') || 'Yeni Kalem Ekle')}
            visible={visible}
            style={{ width: '50vw' }}
            footer={renderFooter()}
            onHide={onHide}
            modal
            className="p-fluid"
        ><div className="col-12">
    <label className="block text-900 font-medium mb-2">
        {th('blockShelfSeqItemDescription.partSource') || 'Parça Kaynağı'}
        <span className="text-red-500 ml-1">*</span>
    </label>

    <div className="flex gap-4 align-items-center">
        <div className="flex align-items-center">
        <RadioButton
            inputId="karsanPart"
            name="partBrand"
            value={0}
            onChange={(e) => handlePartSourceChange(e.value)}
            checked={formData.partBrand === 0}
            disabled={isLoading || !!initialData}
        />      
            <label htmlFor="karsanPart" className="ml-2">
                {th('blockShelfSeqItemDescription.karsanPart') || 'Karsan Parçası'}
            </label>
        </div>

        <div className="flex align-items-center">
            <RadioButton
                inputId="externalPart"
                name="partBrand"
                value={1}
                onChange={(e) => handlePartSourceChange(e.value)}
                checked={formData.partBrand === 1}
                disabled={isLoading || !!initialData}
            />              
            <label htmlFor="externalPart" className="ml-2">
                {th('blockShelfSeqItemDescription.externalPart') || 'Stoğumdaki Harici Parçalar'}
            </label>
             </div>
            </div>
                {submitted && (formData.partBrand === null || formData.partBrand === undefined) && (
        <small className="p-error block mt-1">
            {th('blockShelfSeqItemDescription.validation.partSourceRequired') ||
                'Parça Kaynağı zorunludur'}
        </small>
    )}
        </div>
            <div className="grid">
        <div className="col-12">
            <label htmlFor="partCode" className="block text-900 font-medium mb-2">
                {th('blockShelfSeqItemDescription.partCode') || 'Parça Kodu'} <span className="text-red-500">*</span>
            </label>

{Number(formData.partBrand) === 0 ? (
    <div className={submitted && !formData.partCode ? 'p-invalid' : ''}>
        <ItemCodeDropdown
            value={formData.partCode}
            onChange={(selectedItem) => {
                setFormData((prev) => ({
                    ...prev,
                    partCode: selectedItem?.itemCode || '',
                    partDesc: selectedItem?.title || ''
                }));
            }}
            disabled={isLoading || !!initialData}
        />
    </div>
) : (
    <div className={submitted && !formData.partCode ? 'p-invalid' : ''}>
        <ExternalPartsDropdown
            value={formData.partCode}
            dealerId={userParams.dealerId}
            dealerAddressId={userParams.addrId}
            onChange={(selectedPart) => {
                setFormData((prev) => ({
                    ...prev,
                    partCode: selectedPart?.itemCode || '',
                    partDesc: selectedPart?.title || selectedPart?.itemCodeDesc || ''
                }));
            }}
            disabled={isLoading || !!initialData}
        />
    </div>
)}
            {submitted && !formData.partCode && (
                <small className="p-error block mt-1">
                    {th('blockShelfSeqItemDescription.validation.partCodeRequired') || 'Parça Kodu zorunludur'}
                </small>
            )}
        </div>

                <div className="col-12">
                    <label htmlFor="partDesc">
                        {th('blockShelfSeqItemDescription.partDescription') || 'Parça Açıklaması'}
                    </label>
                    <InputText
                        id="partDesc"
                        value={formData.partDesc}
                        onChange={(e) => handleChange('partDesc', e.target.value)}
                        className={submitted && !formData.partDesc?.trim() ? 'p-invalid' : ''}
                        disabled={isLoading}
                        readOnly
                    />
                    {submitted && !formData.partDesc?.trim() && (
                        <small className="p-error block mt-1">
                            {th('blockShelfSeqItemDescription.validation.partDescriptionRequired') || 'Parça Açıklaması zorunludur'}
                        </small>
                    )}
                </div>

                <div className="col-12">
                    <label htmlFor="block" className="block text-900 font-medium mb-2">
                        {th('blockShelfSeqItemDescription.block') || 'Blok'}
                    </label>
                    <InputText
                        id="block"
                        value={formData.block || ''}
                        onChange={(e) => handleChange('block', e.target.value)}
                        disabled={isLoading}
                    />
                </div>

                <div className="col-12 md:col-6">
                    <label htmlFor="shelf" className="block text-900 font-medium mb-2">
                        {th('blockShelfSeqItemDescription.shelf') || 'Raf'}
                    </label>
                    <InputText
                        id="shelf"
                        value={formData.shelf || ''}
                        onChange={(e) => handleChange('shelf', e.target.value)}
                        disabled={isLoading}
                    />
                </div>

                <div className="col-12 md:col-6">
                    <label htmlFor="sequence" className="block text-900 font-medium mb-2">
                        {th('blockShelfSeqItemDescription.sequence') || 'Sıra'}
                    </label>
                    <InputText
                        id="sequence"
                        value={formData.sequence || ''}
                        onChange={(e) => handleChange('sequence', e.target.value)}
                        disabled={isLoading}
                    />
                </div>

                <div className="col-12 md:col-6">
                    <label htmlFor="eyes" className="block text-900 font-medium mb-2">
                        {th('blockShelfSeqItemDescription.eyes') || 'Göz'}
                    </label>
                    <InputText
                       id="eyes"
                        value={formData.eyes || ''}
                        onChange={(e) => handleChange('eyes', e.target.value)}
                        disabled={isLoading}
                    />
                </div>

                <div className="col-12">
                    <div className="flex align-items-center">
                        <Checkbox
                            inputId="isActive"
                            checked={formData.isActive === 1}
                            onChange={(e) => handleChange('isActive', e.checked ? 1 : 0)}
                            disabled={isLoading}
                        />
                        <label htmlFor="isActive" className="ml-2">
                            {th('common.active') || 'Aktif'}
                        </label>
                    </div>
                </div>
            </div>
            <ConfirmDialog />
        </Dialog>
    );
};

export default BlockShelfSeqItemDescriptionForm;
